<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements and Thanks</a></p>
<p class="toc"><a href="#/Preface">Preface</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. The Early Years</a></p>
<p class="toc"><a href="#/Chapter2#C2">2. Archmere and Delaware</a></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Starting a Family and a Career</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. The First Campaign</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Road to the Senate</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Unspeakable Tragedy</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. The Senate and “Amtrak Joe”</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Jill Biden</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Victory Repeated</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Institutions and Allies</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. Homes</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. On the Town</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. The Kids</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. Eyes on the Prize</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. Professor Biden and Beau’s Rise</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. The Vice Presidency</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. Beau’s Death</span></p>
<p class="toc"><span href="#/Chapter18#C18" title="Link target outside of Sample">18. Faith and Family</span></p>
<p class="toc"><span href="#/Chapter19#C19" title="Link target outside of Sample">19. A Short-Lived Retirement</span></p>
<p class="toc"><span href="#/Chapter20#C20" title="Link target outside of Sample">20. The Delaware Beaches</span></p>
<p class="toc"><span href="#/Chapter21#C21" title="Link target outside of Sample">21. One of Us</span></p>
<p class="toc1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?1f8d0733